import axios from "axios";

import {
  IConfigResponse,
  IVideoCallSessionPayload,
  IVideoCallSessionPostResponse,
  IVideoCallSessionResponse,
} from "@/models/ApiRequestResponse/doctor";
import { IAppLogoutResponse } from "@/models/ApiRequestResponse/patient";
import { GBSCError } from "@/models/GBSCError";
import { IFilterType } from "@/models/patient";
import {
  IFirebaseStatusResponse,
  IInAppNotificationResponse,
  INotificationStatusPayload,
  IParams,
} from "@/models/ApiRequestResponse/notification";
import { IConfigKey } from "@/models";

import { get, post, put } from "@/utils/TypedApi";

import {
  APIEndpoint,
  IAPIStatusCode,
  IAPIStatusType,
  messages,
} from "@/utils/apis/APIEndpointConfig";
import { PAGE_LIMIT } from "@/utils";

export const getConfigDoctorPatientApi = async (
  filterKey?: IFilterType
): Promise<IConfigResponse | GBSCError> => {
  try {
    let url = APIEndpoint.doctor.config;
    const response = await get<IConfigResponse>(
      filterKey ? `${url}?filter=${filterKey}` : url
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const appLogoutApi = async (): Promise<
  IAppLogoutResponse | GBSCError
> => {
  try {
    const response = await post<IAppLogoutResponse>(APIEndpoint.logout, {});
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getInAppNotificationApi = async (
  params: IParams
): Promise<IInAppNotificationResponse | GBSCError> => {
  try {
    const response = await get<IInAppNotificationResponse>(
      `${APIEndpoint.inAppNotification}?page=${params.page}&limit=${PAGE_LIMIT}`
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getFirebaseStatusApi = async (
  payload: INotificationStatusPayload
): Promise<IFirebaseStatusResponse | GBSCError> => {
  try {
    const response = await put<IFirebaseStatusResponse>(
      APIEndpoint.firebaseStatus,
      payload
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getVideoCallSessionApi = async (
  bookingId: string
): Promise<IVideoCallSessionResponse | GBSCError> => {
  try {
    const response = await get<IVideoCallSessionResponse>(
      `${APIEndpoint.videoCallSession}${bookingId}`
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const postVideoCallSessionApi = async (
  bookingId: string,
  payload: IVideoCallSessionPayload
): Promise<IVideoCallSessionPostResponse | GBSCError> => {
  try {
    const response = await post<IVideoCallSessionPostResponse>(
      `${APIEndpoint.videoCallSession}${bookingId}`,
      payload
    );
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.log(ex);
  }
  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};

export const getConfigurationApi = async (
  key: IConfigKey
): Promise<any | GBSCError> => {
  try {
    const url = `${APIEndpoint.patient.getConfig}?key=${key}`;
    const response = await get<any>(url);
    if (response.type === IAPIStatusType.SUCCESS) {
      return response.data;
    }
    const { errorMessage, message, statusCode } = response;
    return new GBSCError(errorMessage, message, statusCode);
  } catch (ex) {
    console.error("Error fetching partner with us data:", ex);
  }

  return new GBSCError(
    IAPIStatusType.ERROR,
    messages.somethingWentWrong,
    IAPIStatusCode.INTERNAL_SERVER_ERROR
  );
};
